/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types'

// @mui material components
import Link from '@mui/material/Link'
// import Icon from "@mui/material/Icon";
import Container from '@mui/material/Container'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'
import SoftTypography from 'components/SoftTypography'

// Soft UI Dashboard PRO React base styles
import typography from 'assets/theme/base/typography'

import { useContext } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { toast } from 'react-toastify'
import { callZapier } from 'utils/zapier/callZapier'
import { Grid } from '@mui/material'

function Footer({ company, links }) {
  const { href, name } = company
  const { size } = typography
  const { intakeState } = useContext(IntakeContext)
  const showJustCallMe =
    intakeState?.firstName &&
    intakeState?.lastName &&
    intakeState?.phone &&
    intakeState?.zipcode
      ? true
      : false

  const renderLinks = () =>
    links.map((link) => (
      <SoftBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <SoftTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </SoftTypography>
        </Link>
      </SoftBox>
    ))

  const footerHelp = () => {
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/38uefcd/',
      payload: {
        user: {
          firstName: intakeState.firstName,
          lastName: intakeState.lastName,
          phoneNumber: intakeState.phone,
          email: intakeState.email,
        },
      },
      sendNotification: true,
      notificationMessage:
        'A request has been sent to PARCO! Expect a call momentarily.',
    })
  }

  return (
    <SoftBox
      position="relative"
      bottom="0"
      width="100%"
      p={2}
      sx={{ backgroundColor: '#262627' }}
      // sx={{ backgroundColor: '#fff', boxShadow: '0px 8px 10px #141727' }}
    >
      <SoftBox
        width="100%"
        display="flex"
        flexDirection={{ xs: 'row', sm: 'column' }}
        alignItems="center"
        justifyContent="space-between"
        px={0}
      >
        <Grid container>
          {/* {showJustCallMe ? (
              <Grid item xs={showJustCallMe ? 5 : 12} sm={12}>
                <SoftButton
                  rel="noreferrer"
                  size="medium"
                  color="error"
                  sx={{ marginBottom: { xs: '0px', sm: '12px' } }}
                  onClick={footerHelp}
                >
                  Just Call Me
                </SoftButton>
              </Grid>
            ) : (
              <></>
            )} */}
          <Grid item xs={12}>
            <SoftBox
              display="flex"
              justifyContent={{ xs: 'left' }}
              flexWrap="wrap"
              color="text"
              fontSize={size.sm}
              fontWeight="500"
              px={{ xs: 0, sm: 1.5 }}
              sx={{ color: '#fff' }}
            >
              &copy; {new Date().getFullYear()}
              &nbsp;{name}
              {/* <Link href={href} target="_blank">
              <SoftTypography variant="button" fontWeight="medium">
                &nbsp;{name}&nbsp;
              </SoftTypography>
            </Link> */}
            </SoftBox>
          </Grid>

          {/* <SoftBox
            component="ul"
            sx={({ breakpoints }) => ({
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'center',
              listStyle: 'none',
              mt: 3,
              mb: 0,
              p: 0,

              [breakpoints.up('lg')]: {
                mt: 0,
              },
            })}
          >
            {renderLinks()}
          </SoftBox> */}
        </Grid>
      </SoftBox>
    </SoftBox>
  )
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: {
    href: 'https://www.goparco.com/',
    name: 'Pensioned Americans Retirement Co.',
  },
  links: [
    { href: 'https://www.goparco.com/about', name: 'About' },
    { href: 'https://www.goparco.com/services', name: 'Services' },
    { href: 'https://www.goparco.com/faq', name: 'FAQ' },
    { href: 'https://www.goparco.com/contact', name: 'Contact' },
    { href: 'https://www.goparco.com/news-updates', name: 'Blog' },
  ],
}

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
}

export default Footer
